import { z } from "zod";

export enum RequestValidationErrorTypeEnum {
    FIELD_REQUIRED_ERROR = 1,
    SQL_VALIDATION_ERROR = 2,
    ATTACHMENT_MISSING_ERROR = 3
}

export const RequestValidationErrorTypeSchema = z.nativeEnum(RequestValidationErrorTypeEnum);